// This icon file is generated automatically.
var DateMbOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5 10.64h1.67v1.67H5v-1.67zm4.17 0h1.66v1.67H9.17v-1.67zm4.16 0H15v1.67h-1.67v-1.67zM5 14.62h1.67v1.66H5v-1.66zm4.17 0h1.66v1.66H9.17v-1.66zm4.16 0H15v1.66h-1.67v-1.66zM1.4 6.34l17.2.02V4a.6.6 0 00-.6-.6h-2.71v.93a.7.7 0 01-1.4 0V3.4H6.37v.92a.7.7 0 01-1.4 0V3.4H2a.6.6 0 00-.6.6v2.33zm0 1.4V18c0 .33.27.6.6.6h16a.6.6 0 00.6-.6V7.76L1.4 7.74zm13.89-5.73H18a2 2 0 012 2v14A2 2 0 0118 20H2a2 2 0 01-2-2V4c0-1.1.9-2 2-2h2.97V.7a.7.7 0 011.4 0V2h7.52V.7a.7.7 0 011.4 0V2z" } }] }, "name": "date-mb", "theme": "outlined" };
export default DateMbOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DateMbOutlined.js
// module id = 2387
// module chunks = 0